export function resolveStrategyAcceptanceChoice({ inDojo, hasPlan, confirmed }) {
  if (!hasPlan) return { proceed: true, replaceExisting: true };
  if (inDojo && !confirmed) return { proceed: false, replaceExisting: true };
  return { proceed: true, replaceExisting: Boolean(confirmed) };
}
